const translate = (key, self) => {
  const list = [
    { key: '正常', val: 'ctcdin6' },
    { key: '黑屏', val: 'ctcdin7' },
    { key: '已开启', val: 'ctcdin8' },
    { key: '未开启', val: 'ctcdin9' },
    { key: 'GPS同步', val: 'ctcdin10' },
    { key: '网络同步', val: 'ctcdin11' },
    { key: '已连接', val: 'ctcdin12' },
    { key: '未连接', val: 'ctcdin13' },
    { key: '未接入', val: 'ctcdin14' },
    { key: '信号弱', val: 'ctcdin15' },
    { key: '正常', val: 'ctcdin16' },
    { key: '信号强', val: 'ctcdin17' },
  ];

  let tItem = list.find(item => item.key === key);
  if (tItem) {
    return self.$t(tItem.val);
  }
  return key;
}

export default translate;